import { UserProfileDtoPersonasItem } from "@/lib/lutely-api/gen/dtos/userProfileDtoPersonasItem";

/**
 * Personas that get the Audiolab workspace: they hold a catalog to publish and
 * sell, so the onboarding tour and Get started tracker apply to them.
 */
const SELLER_PERSONAS: readonly UserProfileDtoPersonasItem[] = [
  UserProfileDtoPersonasItem.artist,
  UserProfileDtoPersonasItem.label_rep,
];

export function hasSellerPersona(
  personas: UserProfileDtoPersonasItem[] | undefined,
): boolean {
  return (personas ?? []).some((persona) => SELLER_PERSONAS.includes(persona));
}
